module.exports = __webpack_public_path__ + "static/media/diff.70d3f248.png";